import { render, staticRenderFns } from "./UpdateEmissionsFactors.vue?vue&type=template&id=608665b2"
import script from "./UpdateEmissionsFactors.vue?vue&type=script&lang=js"
export * from "./UpdateEmissionsFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports